export default __webpack_public_path__ + "static/media/3.805c07be.png";